// Per-project Maps UI gate — replaces global REACT_APP_FEATURE_MAPS / mapsUiEnabled
// from public auth config. Source of truth: GET /api/p/:slug/auth/capabilities
// → modules.maps (resolved from catalog plan + support overrides).

import { useProjectCapabilities } from './useProjectCapabilities';
import { isModuleEnabled } from '../project-modules';

export function useProjectMapsEnabled(projectSlug) {
  const { modules, role, loading } = useProjectCapabilities(projectSlug);
  const mapsEnabled = isModuleEnabled(modules, 'maps');
  return { mapsEnabled, modules, role, loading };
}
